module.exports = __webpack_public_path__ + "img/hat_6.b0a9c972.png";